// tslint:disable
export var CampaignResolutionType;
(function (CampaignResolutionType) {
    // UNKN
    CampaignResolutionType[CampaignResolutionType["UNKN"] = 10001] = "UNKN";
    // REAT
    CampaignResolutionType[CampaignResolutionType["REAT"] = 10002] = "REAT";
    // RMV
    CampaignResolutionType[CampaignResolutionType["RMV"] = 10003] = "RMV";
    // VER
    CampaignResolutionType[CampaignResolutionType["VER"] = 10004] = "VER";
    // DEN
    CampaignResolutionType[CampaignResolutionType["DEN"] = 10005] = "DEN";
    // NOC
    CampaignResolutionType[CampaignResolutionType["NOC"] = 10006] = "NOC";
    // PHN
    CampaignResolutionType[CampaignResolutionType["PHN"] = 10007] = "PHN";
    // FLUP
    CampaignResolutionType[CampaignResolutionType["FLUP"] = 10008] = "FLUP";
})(CampaignResolutionType || (CampaignResolutionType = {}));
//# sourceMappingURL=CampaignResolutionType.js.map